import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/blogs/[slug]/components/BlogDetailContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/common/ClientFooter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/common/PublicHeader.tsx");
